import { z } from "zod";
import { BaseAnalyticsEvent } from "./base";
// When someone installs the SDK for the first time
export const Onboarding_SDKInstall = BaseAnalyticsEvent.extend({
    name: z.literal("Onboarding_SDKInstall")
});
// When someone presents a paywall for the first time
export const Onboarding_PaywallPresent = BaseAnalyticsEvent.extend({
    name: z.literal("Onboarding_PaywallPresent")
});
// When someone completes a purchase for the first time
export const Onboarding_PurchaseComplete = BaseAnalyticsEvent.extend({
    name: z.literal("Onboarding_PurchaseComplete")
});
// When someone creates a product for the first time
export const Onboarding_ProductCreate = BaseAnalyticsEvent.extend({
    name: z.literal("Onboarding_ProductCreate")
});
// When someone adds the product to the paywall
export const Onboarding_AddProductToPaywall = BaseAnalyticsEvent.extend({
    name: z.literal("Onboarding_AddProductToPaywall")
});
// When someone completes a production purchase for the first time
export const Onboarding_ProductionTransactionComplete = BaseAnalyticsEvent.extend({
    name: z.literal("Onboarding_ProductionTransactionComplete")
});
// When the onboarding is actually complete
export const Onboarding_Complete = BaseAnalyticsEvent.extend({
    name: z.literal("Onboarding_Complete")
});
